import {
  Box,
  Grid,
  TextField,
  createTheme,
  ThemeProvider,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import MUIDataTable from "mui-datatables";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import { groupSettingsApi, typeSettingsApi } from "../../../Data/axios";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function TicketTypes() {
  const [open, setOpen] = React.useState(false);
  const [updateGroup, setUpdateGroup] = React.useState("");
  const [group, setGroup] = React.useState("");

  const [leadSource, setLeadSource] = useState([]);
  const [data, setData] = useState([]);

  const [update, setUpdate] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleClickUpdate = () => {
    setUpdate(true);
  };

  const handleUpdateClose = () => {
    setUpdate(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const response = await typeSettingsApi.getAll();
    setLeadSource(response.data);
  }

  const columns = [
    {
      name: "type",
      label: "Name ",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Name
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },

    {
      name: "id", // Assuming this is the name of the column containing the ID
      label: "Actions",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "70px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value) => (
          <>
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "flex-end", // Aligns content to the left
                alignItems: "center",
                paddingRight: "20px", // Add padding for starting point
              }}
            >
              <Stack spacing={2} direction="row">
                <Button variant="outlined" onClick={() => handleEdit(value)}>
                  {" "}
                  <EditNoteIcon /> Update
                </Button>
                <Button variant="outlined" onClick={() => handleDelete(value)}>
                  {" "}
                  <DeleteForeverIcon /> Delete
                </Button>
              </Stack>
            </div>
          </>
        ),
      },
    },
  ];

  // Save Lead Sourse
  const item = {
    type: group,
  };
  async function SaveDate() {
    try {
      const formData = new FormData();
      for (const key in item) {
        if (item[key] !== undefined && item[key] !== null) {
          formData.append(key, item[key]);
        }
      }
      await typeSettingsApi.add(formData);
      showAlert("Ticket Group Added Successfully!", "success");
      getData();
      setOpen(false);
    } catch (error) {
      console.error("Fetch error:", error);
      showAlert("Failed to add Ticket Group", "error");
    }
  }
  async function handleEdit(id) {
    const result = await typeSettingsApi.edit(id);
    setData(result);

    handleClickUpdate();
  }
  useEffect(() => {
    setUpdateGroup(data.type);
  }, [data.type]);
  async function UpdateData() {
    const formData = new FormData();
    formData.append("type", updateGroup);
    try {
      await typeSettingsApi.update(data.id, formData);
      showAlert(" Updated successfully", "success");
      handleUpdateClose();
      getData();
    } catch (error) {
      console.error(error);
      showAlert("Failed to update ", "error");
    }
  }

  async function handleDelete(id) {
    await typeSettingsApi.delete(id);
    getData();
    showAlert(" Deleted successfully", "warning");
  }

  const options = {
    selectableRows: "none",
    selectToolbarPlacement: "none",
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 25, 100],
    tableBody: {
      style: {
        maxHeight: "500px",
        overflowY: "scroll",
        marginLeft: "5PX",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {
        marginLeft: "5px",
        textAlign: "center",
      },
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  return (
    <>
      <Box>
        <Dialog
          fullWidth
          maxWidth="sm"
          open={update}
          onClose={handleUpdateClose}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              position: "absolute",
              background: "#141b2d",
              top: "0",
              backgroundColor: "white",
              maxHeight: "95%",
              margin: "auto",
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleUpdateClose}
                aria-label="close"
              >
                <CloseIcon fontSize="large" />
              </IconButton>
              <Typography
                sx={{ ml: 2, flex: 1, fontSize: "18px" }}
                component="div"
              >
                Update Type
              </Typography>
            </Toolbar>
          </AppBar>
          <Box
            component="form"
            sx={{
              p: 2,
              bgcolor: "#fff",
              borderRadius: 1,
              boxShadow: 1,
            }}
          >
            <Grid
              container
              spacing={2}
              style={{ color: "black", margin: "10px" }}
            >
              <Grid item xs={12} sm={10}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Type Name
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Enter Type Name"
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      value={updateGroup}
                      onChange={(e) => setUpdateGroup(e.target.value)}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "10px 0 20px 20px" }}>
              <Grid item sx={11} className="messageFooter">
                <Box className="response" onClick={UpdateData}>
                  Update
                </Box>
                <Box className="cancel" onClick={handleUpdateClose}>
                  Cancel
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Dialog>
      </Box>
      <List style={{ background: "none", padding: 5 }}>
        <StatusAlert
          open={alertOpen}
          setOpen={setAlertOpen}
          message={alertMessage}
          severity={alertSeverity}
        />
        <ListItemText style={{ background: "none", margin: 5 }}>
          <React.Fragment>
            <Box
              onClick={handleClickOpen}
              sx={{
                backgroundColor: "#1d82f5",
                "&:hover": { backgroundColor: "orange" },
                textAlign: "center",
                padding: "10px",
                marginLeft: "10px",
                height: "40px",
                width: "155px",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                borderRadius: "4px",
                fontSize: "15px",
                fontFamily: "sans-serif",
                cursor: "pointer",
              }}
            >
              <AddCircleIcon /> Add New Type
            </Box>
            <Dialog
              fullWidth
              maxWidth="sm"
              open={open}
              onClose={handleClose}
              TransitionComponent={Transition}
              PaperProps={{
                style: {
                  position: "absolute",
                  background: "#fff",
                  top: "0",
                  backgroundColor: "white",
                  maxHeight: "95%",
                  margin: "auto",
                  overflowX: "hidden",
                  zIndex: 1200,
                },
              }}
            >
              <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                  >
                    <CloseIcon fontSize="large" />
                  </IconButton>
                  <Typography
                    sx={{ ml: 2, flex: 1, fontSize: "18px" }}
                    component="div"
                  >
                    Add Type
                  </Typography>
                </Toolbar>
              </AppBar>
              <Box
                component="form"
                sx={{
                  p: 2,
                  bgcolor: "#fff",
                  borderRadius: 1,
                  boxShadow: 1,
                }}
              >
                <Grid
                  container
                  spacing={2}
                  style={{ color: "black", margin: "10px" }}
                >
                  <Grid item xs={12} sm={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Type Name
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          placeholder="Enter Type Name"
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          onChange={(e) => setGroup(e.target.value)}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "10px 0 20px 20px" }}>
                  <Grid item sx={11} className="messageFooter">
                    <Box className="response" onClick={SaveDate}>
                      Save
                    </Box>
                    <Box className="cancel" onClick={handleClose}>
                      Cancel
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Dialog>
          </React.Fragment>
        </ListItemText>
        <Divider />
        <ListItemText style={{ background: "white", margin: 0, width: "100%" }}>
          <ThemeProvider theme={getTheme()}>
            <MUIDataTable
              title={
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    color: "#333",
                  }}
                >
                  Ticket Type Lists
                </span>
              }
              data={leadSource}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </ListItemText>
      </List>
    </>
  );
}

export default TicketTypes;
